import { Row, Col, Button } from 'antd';
import {ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

export default class ReactivateUser extends React.Component {
    componentDidMount() {
        const
        s = this.state,
        { services, state} = this.props;
        services.candidateAccountReactivation(this.props.token);
    }
    clickLink() {
        const path = ssCommonUtils.setEnvPrefix('/home');
        window.location.href=(path );
    }
    render() {
        if (this.props.state.accountReactivation.success === true) { 

        return (
            <div className='afsp-login-indicator-status-error'>
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                    <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                    <p>Your account has been reactivated.</p>
                    </span>
                  <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '16px' }}>
                        <Col span={24}>
                        <Button onClick={() => this.clickLink()}>Home</Button>
                        </Col>
                    </Row>
                </div>
            </div>

            );
        }else{
            return (
                <div className='afsp-login-indicator-status-error'>
                    <div style={{ textAlign: 'center', marginTop: '15px' }}>
                        <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                        <p>Invalid Account Reactivation Link.</p>
                        </span>
                      <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '16px' }}>
                            <Col span={24}>
                            <Button onClick={() => this.clickLink()}>Home</Button>
                            </Col>
                        </Row>
                    </div>
                </div>);
    
        }

    
    }
}
